import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetExcuteAsync, resetRequestAsync } from "./operations";
import { ResetState } from "./state";

const initialState: ResetState = {
  apps: {
    pageState: "sendMail",
    email: "",
    password: "",
    passwordCheck: "",
    code: "",
  },
  error: {},
};

export const resetSlice = createSlice({
  name: "reset",
  initialState,
  reducers: {
    changeEmail: (state, action: PayloadAction<{ email: string }>) => {
      const { email } = action.payload;
      state.apps.email = email;
    },
    changePassword: (state, action: PayloadAction<{ password: string }>) => {
      const { password } = action.payload;
      state.apps.password = password;
    },
    changePasswordCheck: (
      state,
      action: PayloadAction<{ passwordCheck: string }>
    ) => {
      const { passwordCheck } = action.payload;
      state.apps.passwordCheck = passwordCheck;
    },
    changeCode: (state, action: PayloadAction<{ code: string }>) => {
      const { code } = action.payload;
      state.apps.code = code;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetRequestAsync.pending, (state) => {
      state.error = {};
    });
    builder.addCase(resetRequestAsync.fulfilled, (state) => {
      state.apps.pageState = "excute";
    });
    builder.addCase(resetRequestAsync.rejected, (state, action) => {
      const { payload } = action;
      state.error = { resetRequestError: payload?.error };
    });
    builder.addCase(resetExcuteAsync.pending, (state) => {
      state.error = {};
    });
    builder.addCase(resetExcuteAsync.fulfilled, (state) => {
      state.apps.pageState = "complete";
    });
    builder.addCase(resetExcuteAsync.rejected, (state, action) => {
      const { payload } = action;
      state.error = { resetExcuteError: payload?.error };
    });
  },
});
export const { changeEmail, changePassword, changePasswordCheck, changeCode } =
  resetSlice.actions;
export default resetSlice.reducer;
